<template>
    <div class="page-news">

        <SearchHead
            v-model="pgData.title"
            @search="$refs.page.queryData()"
            @reset="$refs.page.queryData()"
        ></SearchHead>

        <div class="content">
            <commonList :tableData="tableData" :loading="loading" name="title" time="pubdate"
                :createUrl="buildDetailUrl">
            </commonList>

            <my-pagination
                ref="page"
                v-model="tableData"
                :loading.sync="loading"
                action="/college/news/pglist"
                :search="pgData"
                :afterQuery="afterQuery"
            ></my-pagination>
        </div>
    </div>
</template>

<script>
import SearchHead from '@components/sys/search-head.vue';
import commonList from '../../notice/components/common-list.vue';

export default {
    components: {
        SearchHead,
        commonList,
    },
    data() {
        return {
            pgData: {
                title: '',
            },
            loading: true,

            tableData: [],
        };
    },
    methods: {
        afterQuery(data){
            data.map(r=>{
                r.pubdate = r.pubdate.substr(0,10)
            })
        },
        buildDetailUrl: function(item) {
            var { guid, } = item;

            return `/news/${guid}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.page-news {
    padding-bottom: 40px;
    min-height: 600px;
}

</style>